/** @format */

import moment from 'moment';
import { action, thunk } from 'easy-peasy';
import { GetTravelRequest } from '../../utils/Utils.js';
import { isErrorResponse, getTravels } from '../../api/api';

const cacheGet = (cache, date) => cache.get(moment(date).dayOfYear());
const cacheHit = (cachedTravels) => cachedTravels != null && cachedTravels !== 'loading';

const TravelsSelectModel = {
	error: null,
	fromStopName: null,
	toStopName: null,
	searchDate: null,
	travelsOutCache: new Map(),
	travelsOut: null,
	lastClickedTravel: null,

	//Thunks
	fetchTravelsOut: thunk(async (actions, data) => {
		let { travelSearchData, travelsSelectData } = data;
		// remove timezone from date
		const date = travelSearchData.departureDate.format('YYYY-MM-DDTHH:mm:ss');
		actions.setSearchDate(date);

		//Check Cache
		let cachedTravels = cacheGet(travelsSelectData.travelsOutCache, date);

		if (cacheHit(cachedTravels)) {
			actions.setTravelsOut({ t: cachedTravels, d: date });
			return;
		}
		actions.setTravelsOut({ t: 'loading', d: date });

		const requestOut = GetTravelRequest(
			date,
			travelSearchData.fromStop.id,
			travelSearchData.toStop.id,
			travelSearchData.selectedItems
		);

		const taskGetTravelsOut = await getTravels(requestOut);
		const resGetTravelsOut = await taskGetTravelsOut;

		let travelsOut;
		if (isErrorResponse(resGetTravelsOut)) {
			actions.setError(resGetTravelsOut);
			actions.setTravelsOut({ t: resGetTravelsOut, d: date });
		} else {
			// only return  trips with departure after current time
			travelsOut = resGetTravelsOut.filter(
				(x) => x.departure >= moment().add(process.env.REACT_APP_DEPARTURE_MIN_OFFSET, 'minutes').format()
			);

			actions.setTravelsOut({ t: travelsOut, d: date });
		}
	}),

	// Actions
	setLastClickedTravel: action((state, travel) => {
		state.lastClickedTravel = travel;
	}),
	setError: action((state, error) => {
		state.error = error;
	}),
	setSearchDate: action((state, d) => {
		state.searchDate = d;
	}),
	setTravelsOut: action((state, { t, d }) => {
		let key = moment(d).dayOfYear();
		state.travelsOutCache.set(key, t);
		// Check if user selected date is the same as the one we just fetched
		if (key === moment(state.searchDate).dayOfYear()) {
			state.travelsOut = t;
		}
	}),
	setStops: action((state, travelSearch) => {
		state.fromStopName = travelSearch.stopIdDepartureName;
		state.toStopName = travelSearch.stopIdArrivalName;
	}),
	reset: action((state) => {
		state.fromStopName = null;
		state.toStopName = null;
		state.searchDate = null;
		state.travelsOut = null;
		state.lastClickedTravel = null;
		state.travelsOutCache = new Map();
	}),
};

export default TravelsSelectModel;
